var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "c-mostRatedCategories" }, [
    _c("h2", { staticClass: "c-statusChart_title" }, [
      _vm._v("ESPECIALIDADES MAIS COTADAS"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-mostRatedCategories_body" },
      _vm._l(_vm.mostRatedCategories, function (item, index) {
        return _c(
          "a",
          {
            key: index,
            staticClass: "c-mostRatedCategories_card",
            attrs: { href: _vm.categoryLink(item.categorySlug) },
          },
          [
            _c(_vm.getIcon(item.category), {
              tag: "component",
              staticClass: "c-mostRatedCategories_icon",
            }),
            _vm._v(" "),
            _c("h3", { staticClass: "c-mostRatedCategories_name" }, [
              _vm._v(_vm._s(item.description)),
            ]),
            _vm._v("\n\n      " + _vm._s(item.slug) + "\n    "),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }